var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 42,
    viewBox: "0 0 24 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_15898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.145 13.71V10.2825H6.855V13.71H0V24H24V13.71H17.145ZM6.855 22.8525H1.1475V14.8575H6.855V22.8525ZM15.9975 22.8525H8.0025V11.43H15.9975V22.8525ZM22.86 22.8525H17.145V14.8575H22.86V22.8525Z",
    fill: "#3DD22B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7124 15.9976H18.2849V17.1451H20.5724V18.2851H18.2849V19.4251H20.5724V20.5726H18.2849V21.7126H21.7124V15.9976Z",
    fill: "#3DD22B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7126 4.56738H19.4326V5.71488H21.7126V4.56738Z",
    fill: "#3DD22B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4324 0H18.2849V1.14H19.4324V0Z",
    fill: "#3DD22B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.285 1.13989H17.145V2.28739H18.285V1.13989Z",
    fill: "#3DD22B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7175 17.1451H12.57V12.5701H10.29V13.7101H11.43V17.1451H10.29V18.2851H13.7175V17.1451Z",
    fill: "#3DD22B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5699 0H11.4299V2.2875H12.5699V0Z",
    fill: "#3DD22B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85498 3.42749V7.99499H8.00248V9.14249H15.9975V7.99499H17.145V3.42749H15.9975V4.56749H14.8575V5.71499H13.7175V4.56749H12.57V3.42749H11.43V4.56749H10.29V5.71499H9.14248V4.56749H8.00248V3.42749H6.85498ZM13.7175 6.85499H14.8575V7.99499H13.7175V6.85499ZM11.43 6.85499H12.57V7.99499H11.43V6.85499ZM9.14248 6.85499H10.29V7.99499H9.14248V6.85499Z",
    fill: "#3DD22B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85509 1.13989H5.71509V2.28739H6.85509V1.13989Z",
    fill: "#3DD22B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71495 0H4.57495V1.14H5.71495V0Z",
    fill: "#3DD22B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7151 20.5726H3.4276V19.4251H5.7151V15.9976H2.2876V17.1451H4.5751V18.2851H2.2876V21.7126H5.7151V20.5726Z",
    fill: "#3DD22B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5751 4.56738H2.2876V5.71488H4.5751V4.56738Z",
    fill: "#3DD22B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.74609 34.6523V36.6055H4.1875V36.1172H4.67578V35.1406H4.1875V34.6523H1.74609ZM2.23438 37.582H1.74609V40.5117H0.769531V33.6758H4.67578V34.1641H5.16406V34.6523H5.65234V36.6055H5.16406V37.0938H4.67578V37.582H3.69922V38.0703H4.1875V38.5586H4.67578V39.0469H5.16406V39.5352H5.65234V40.5117H4.67578V40.0234H4.1875V39.5352H3.69922V39.0469H3.21094V38.5586H2.72266V38.0703H2.23438V37.582ZM7.60547 37.582H10.5352V36.1172H10.0469V35.6289H9.55859V35.1406H8.58203V35.6289H8.09375V36.1172H7.60547V37.582ZM7.60547 40.5117H6.62891V35.6289H7.11719V35.1406H7.60547V34.6523H8.09375V34.1641H8.58203V33.6758H9.55859V34.1641H10.0469V34.6523H10.5352V35.1406H11.0234V35.6289H11.5117V40.5117H10.5352V38.5586H7.60547V40.5117ZM13.4648 36.6055V40.5117H12.4883V33.6758H13.4648V35.1406H13.9531V35.6289H14.4414V36.1172H14.9297V36.6055H15.418V37.0938H15.9062V37.582H16.3945V33.6758H17.3711V40.5117H16.3945V39.0469H15.9062V38.5586H15.418V38.0703H14.9297V37.582H14.4414V37.0938H13.9531V36.6055H13.4648ZM19.3242 37.582V40.5117H18.3477V33.6758H19.3242V36.6055H19.8125V36.1172H20.3008V35.6289H20.7891V35.1406H21.2773V34.6523H21.7656V34.1641H22.2539V33.6758H23.2305V34.6523H22.7422V35.1406H22.2539V35.6289H21.7656V36.1172H21.2773V36.6055H20.7891V37.582H21.2773V38.0703H21.7656V38.5586H22.2539V39.0469H22.7422V39.5352H23.2305V40.5117H22.2539V40.0234H21.7656V39.5352H21.2773V39.0469H20.7891V38.5586H20.3008V38.0703H19.8125V37.582H19.3242Z",
    fill: "#3DD22B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_15898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank);
export default __webpack_public_path__ + "static/media/Rank.55b34bb632505c40dc5b3c7c04adcd44.svg";
export { ForwardRef as ReactComponent };